
const Footer = () => {
  return (
    <p className='clearfix mb-0'>
      <span className='float-md-left d-block d-md-inline-block mt-25'>
        © {new Date().getFullYear()} Bản quyền thuộc về{' '}
        <a href='https://cyberlotus.com/' target='_blank' rel='noopener noreferrer'>
          <span color='primary'>CyberLotus</span>
        </a>
        <span className='d-none d-sm-inline-block'></span>
      </span>
      <span className='float-md-right d-none d-md-block'>
      </span>
    </p>
  )
};

export default Footer;
// COPYRIGHT © {new Date().getFullYear()}{' '}
